export const topmenu = {
  account: "Kundkonto",
  homes: "Boenden",
  users: "Brukare",
  staff: "Personal",
  overview: "Överblick",
  awards: "Awards",
  statistics: "Statistik",
  calendar: "Kalender",

  access_level_super_admin: "Super",
  access_level_account_admin: "Behörighet 1",
  access_level_operations_manager: "Behörighet 2",
  access_level_home_manager: "Behörighet 3",
  logged_in_with: "Inloggad med ",
};
